// screens/DriverTransferRequest/DriverTransferRequestDetailScreen.jsx
import React from "react";
import { useParams } from "react-router-dom";
import { Divider } from "@mui/material";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useGetDriverTransferRequestDetailQuery } from "store/services/driverTransferRequestApi";

import { DriverTransferRequestDetailContext } from "contexts/DriverTransferRequestDetailContext";
import DriverTransferRequestBasicDetail from "./driverComponents/DriverTransferRequestBasicDetail";
import DriverTransferRequestLoadingSnapshot from "./driverComponents/DriverTransferRequestLoadingSnapshot";

const DriverTransferRequestDetailScreen = () => {
  const { id } = useParams();

  const breadcrumbs = [
    {
      title: "Driver Transfer Requests",
      path: "/app/crm/load-transfer/list",
    },
    { title: "Transfer Request Detail" },
  ];

  const {
    data: transferRequestDetail,
    isLoading: loadingTransferRequest,
    error,
  } = useGetDriverTransferRequestDetailQuery(id);

  return (
    <DriverTransferRequestDetailContext.Provider
      value={{ transferRequestDetail, loadingTransferRequest }}
    >
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingTransferRequest}
      >
        <BreadcrumbLayout.Error error={error} />
        <BreadcrumbLayout.Paper>
          <DriverTransferRequestBasicDetail />
          <Divider />
          <DriverTransferRequestLoadingSnapshot />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </DriverTransferRequestDetailContext.Provider>
  );
};

export default DriverTransferRequestDetailScreen;